import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import { ProjectCreateDrawerConsumer } from '@atlassian/jira-project-create-drawer-context/src/index.tsx';
import ProjectCreate from '@atlassian/jira-project-create-main/src/async.tsx';
import View from './main.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { OpenDrawerMethod } from './types';

type onCloseArgs = {
	screen: string;
	canCreateNextGenProject: boolean;
	canCreateClassicProject: boolean;
	isAdmin: boolean;
	// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
	projectComparisonScreen: void; // sees to be unused prop
};

export default withFireUiAnalytics({
	onClose: ({
		screen,
		canCreateClassicProject,
		canCreateNextGenProject,
		isAdmin,
		projectComparisonScreen,
	}: onCloseArgs) => ({
		name: 'projectCreate',
		screen,
		canCreateClassic: canCreateClassicProject,
		canCreateNextGen: canCreateNextGenProject,
		isAdmin,
		projectComparisonScreen,
	}),
})(
	withInjectedProps(View, {
		Consumer: ProjectCreateDrawerConsumer,
		ProjectCreate,
	}),
);
